import { features } from '@/mocks/home';

export default function GameFeatures() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-secondary-50 text-secondary-700 mb-4 whitespace-nowrap">
            游戏特色
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            六大核心<span className="text-primary-600">体验</span>
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            精心打造的游戏系统，为你带来全方位的沉浸式樱境之旅。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group p-7 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}